import React, { useState } from 'react';
import { Link } from "react-router-dom";
import {
  Box, Button, Collapse, FormControl, IconButton, InputLabel, MenuItem,
  Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, Typography, Menu, ListItemIcon, ListItemText, Pagination, Checkbox
} from '@mui/material';
import { ExpandMore, ExpandLess, Search, History, MoreVert, List, Edit, Close } from '@mui/icons-material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Navbar from '../Layouts/Navbar';
import MenuIcon from '@mui/icons-material/Menu';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import HistoriqueModal from './HistoriqueModal';
import { getCurrentUser } from '../../utils/auth';

export default function ReservationTable() {
  const [openhis, setOpenHis] = useState(false);
  const handleOpenHis = () => setOpenHis(true);
  const handleCloseHis = () => setOpenHis(false);
  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };

  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  
  // State for selected rows/checkboxes
  const [selected, setSelected] = useState([]);
  const [groupAction, setGroupAction] = useState('');

  // Get current user role
  const currentUser = getCurrentUser();
  const isAdmin = parseInt(currentUser?.ID_Role) === 1;

  const rows = [
    {
      id: 1,
      nom: 'TEST Yousra FANID',
      trajet: 'ZONE 10: MABROUKA',
      pickup: '02 AV 4ÈME DMM - SALADBOX VICTOR HUGO',
      dropoff: 'Toubkal',
      direction: 'Entrée',
      date: '26-03-2025',
      heure: '9',
      etat: 'validée'
    },
    {
      id: 2,
      nom: 'TEST Yousra FANID',
      trajet: 'ZONE 10: MABROUKA',
      pickup: 'Toubkal',
      dropoff: '02 AV 4ÈME DMM - SALADBOX VICTOR HUGO',
      direction: 'Sortie',
      date: '26-03-2025',
      heure: '18',
      etat: 'validée'
    },
    {
      id: 3,
      nom: 'TEST Mohamed BOURHALI',
      trajet: 'ZONE 10: MABROUKA',
      pickup: '06 NAJD - PHARMACIE NAJD',
      dropoff: 'Toubkal',
      direction: 'Entrée',
      date: '26-03-2025',
      heure: '8',
      etat: 'validée'
    },
    {
      id: 4,
      nom: 'TEST Mohamed BOURHALI',
      trajet: 'ZONE 10: MABROUKA',
      pickup: 'Toubkal',
      dropoff: '06 NAJD - PHARMACIE NAJD',
      direction: 'Sortie',
      date: '26-03-2025',
      heure: '17',
      etat: 'validée'
    },
    {
      id: 5,
      nom: 'TEST Mohamed Karim LARHRIB',
      trajet: 'ZONE 10: MABROUKA',
      pickup: 'Toubkal',
      dropoff: '02 AV 4ÈME DMM - SALADBOX VICTOR HUGO',
      direction: 'Sortie',
      date: '26-03-2025',
      heure: '16',
      etat: 'validée'
    },
  ];

  const handleDelete = () => {
    try {
      // Delete logic would go here
      handleSnack('Réservation(s) supprimée(s) avec succès', 'success');
      handleMenuClose();
    } catch (error) {
      handleSnack("Erreur lors de la suppression de la réservation", 'error');
    }
  };

  const handleModify = () => {
    try {
      // Modify logic would go here
      handleSnack('Réservation modifiée avec succès', 'success');
      handleMenuClose();
    } catch (error) {
      handleSnack("Erreur lors de la modification de la réservation", 'error');
    }
  };

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map(n => n.id);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleGroupAction = () => {
    if (groupAction === 'navette' && selected.length > 0) {
      handleSnack('Navette assignée avec succès', 'success');
      setGroupAction('');
    }
  };

  const paginatedRows = rows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(rows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <AccessTimeIcon />
            <Typography variant="h6">RÉSERVATIONS</Typography>
          </Box>
          <Box display="flex" gap={2}>
            <Button variant="outlined" sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
            }} startIcon={<InsertDriveFileIcon />}>Exporter</Button>
            
            {/* Only show Recap button for Admin (role 1) */}
            {isAdmin && (
              <Button variant="outlined" component={Link} to="/recap-reservation" sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }} startIcon={<MenuIcon />}>Recap des réservations</Button>
            )}
          </Box>
        </Box>

        {/* Search Section */}
        <Paper variant="outlined" sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1} mt={1} onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <Search />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>RECHERCHER</Typography>
            <IconButton>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
        </Paper>

        <Collapse in={open}>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Box display="flex" gap={2} mb={2}>
              <TextField
                type="date"
                label="Date"
                InputLabelProps={{ shrink: true }}
                fullWidth size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  },
                  '& .MuiInputLabel-root': {
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                  }
                }}
              />
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Heure</InputLabel>
                <Select label="Heure">
                  <MenuItem value="8">8:00</MenuItem>
                  <MenuItem value="9">9:00</MenuItem>
                  <MenuItem value="17">17:00</MenuItem>
                  <MenuItem value="18">18:00</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Trajet</InputLabel>
                <Select label="Trajet">
                  <MenuItem value="ZONE 10: MABROUKA">ZONE 10: MABROUKA</MenuItem>
                  <MenuItem value="ZONE 14: SIDI YOUSSEF">ZONE 14: SIDI YOUSSEF</MenuItem>
                </Select>
              </FormControl>
            </Box>
            
            <Box display="flex" gap={2} mb={2}>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Pickup</InputLabel>
                <Select label="Pickup">
                  <MenuItem value="Toubkal">Toubkal</MenuItem>
                  <MenuItem value="02 AV 4ÈME DMM">02 AV 4ÈME DMM</MenuItem>
                  <MenuItem value="06 NAJD">06 NAJD</MenuItem>
                </Select>
              </FormControl>
              
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Direction</InputLabel>
                <Select label="Direction">
                  <MenuItem value="Entrée">Entrée</MenuItem>
                  <MenuItem value="Sortie">Sortie</MenuItem>
                </Select>
              </FormControl>
            </Box>
            
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Button variant="outlined" sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}>Reset</Button>
              <Button variant="outlined" sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}>Search</Button>
            </Box>
          </Paper>
        </Collapse>

        {/* Bulk Actions */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography>Actions groupées</Typography>
            <FormControl size="small" sx={{
                minWidth: 150 ,
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
              <Select
                value={groupAction}
                onChange={(e) => setGroupAction(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled><em>Sélectionner</em></MenuItem>
                <MenuItem value="navette">Navette</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="contained"
              disabled={!groupAction || selected.length === 0}
              onClick={handleGroupAction}
              sx={{
                bgcolor: 'red',
                textTransform: 'none',
                '&:hover': { bgcolor: 'red' },
                '&.Mui-disabled': { bgcolor: '#f5f5f5', color: '#bdbdbd' }
              }}
            >
              Appliquer
            </Button>
          </Box>
          <Typography>{selected.length} sélectionnés / {rows.length} entrées</Typography>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    indeterminate={selected.length > 0 && selected.length < rows.length}
                    checked={rows.length > 0 && selected.length === rows.length}
                    onChange={handleSelectAll}
                    sx={{
                        '&.MuiCheckbox-indeterminate': {
                          color: '#000',
                        },
                        '&.Mui-checked': {
                          color: '#000',
                        },
                      }}
                  />
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Nom</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Trajet</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Pick-up</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Drop-off</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Direction</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Heure</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>État</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.map((row) => {
                const isItemSelected = isSelected(row.id);
                return (
                  <TableRow 
                    key={row.id} 
                    hover
                    selected={isItemSelected}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isItemSelected}
                        onChange={(event) => handleSelectOne(event, row.id)}
                        sx={{
                          '&.MuiCheckbox-indeterminate': {
                            color: '#000',
                          },
                          '&.Mui-checked': {
                            color: '#000',
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>{row.nom}</TableCell>
                    <TableCell>{row.trajet}</TableCell>
                    <TableCell>{row.pickup}</TableCell>
                    <TableCell>{row.dropoff}</TableCell>
                    <TableCell>{row.direction}</TableCell>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.heure}</TableCell>
                    <TableCell>
                      <Box 
                        sx={{ 
                          backgroundColor: '#4caf50', 
                          color: 'white', 
                          borderRadius: '4px',
                          px: 1,
                          py: 0.5,
                          display: 'inline-block',
                          fontSize: '0.8rem',
                          textTransform: 'capitalize'
                        }}
                      >
                        {row.etat}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={(e) => handleMenuClick(e, row.id)}>
                        <MoreVert />
                      </IconButton>
                      <Menu 
                        anchorEl={anchorEl} 
                        open={menuRowId === row.id && openMenu} 
                        onClose={handleMenuClose} 
                        PaperProps={{
                          sx: {
                            minWidth: "200px",
                            "& .MuiMenuItem-root": {
                              color: "black",
                              "& .MuiListItemIcon-root": {
                                color: "black",
                              },
                              "&:hover": {
                                backgroundColor: "red",
                                color: "white",
                                "& .MuiListItemIcon-root": {
                                  color: "white",
                                },
                              },
                            },
                          },
                        }}
                      >
                        <MenuItem component={Link} to="/reservation-detail">
                          <ListItemIcon><List fontSize="small" /></ListItemIcon>
                          <ListItemText>Détail</ListItemText>
                        </MenuItem>
                        <MenuItem component={Link} to="/edit-reservation">
                          <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
                          <ListItemText>Modifier</ListItemText>
                        </MenuItem>
                        <MenuItem sx={{ color: 'red' }}>
                          <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                          <ListItemText onClick={handleOpenHis}>Historique</ListItemText>
                        </MenuItem>
                        <MenuItem>
                          <ListItemIcon><Close fontSize="small" /></ListItemIcon>
                          <ListItemText onClick={handleDelete}>Annuler</ListItemText>
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{rows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>
      </Box>

      <Snackbar 
        open={snack.open} 
        autoHideDuration={3000} 
        onClose={handleCloseSnack} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert 
          onClose={handleCloseSnack} 
          severity={snack.type} 
          elevation={6} 
          variant="filled" 
          sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>

      <HistoriqueModal open={openhis} handleClose={handleCloseHis} />
    </Box>
  );
}